

















































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import collectorModelPo from "@/store/entities/devices/collectormodelpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
@Component({
  components: { TreeSelect },
})
export default class EditMeterModel extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  collectorModelPo: collectorModelPo = new collectorModelPo();
  async created() {
    this.areaTree();
    this.getItemDetail();
    await this.organizetiontree();
  }
  //组织数据
  async organizetiontree() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizetionData = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  save() {
    (this.$refs.modelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "collectormodel/update",
          data: this.collectorModelPo,
        });
        (this.$refs.modelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.modelForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      console.log(this.$store.state.collectormodel.collectorModelItems)
      this.collectorModelPo = Util.extend(
        true,
        {},
        this.$store.state.collectormodel.collectorModelItems
      );
    }
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      detaillist.forEach((ele) => {
        if (ele.itemId == 3) {
          this.$data.ispType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 5) {
          this.$data.potocolType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 4) {
          this.$data.deviceType.push({ label: ele.name, value: ele.id });
        }
      });
    }
  }
  modelRule = {
    name: [
      {
        required: true,
        message: this.L("Name") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        type: "number",
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Organization")),
        trigger: "blur",
      },
    ],
    protocol: [
      {
        required: true,
        type: "integer",
        message: this.L("Protocol") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    isp: [
      {
        required: true,
        type: "integer",
        message: this.L("ISP") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceTypeId: [
      {
        required: true,
        type: "integer",
        message:
          this.L("Device") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [],
      ispType: [],
      potocolType: [],
      organizetionData: [],
      deviceType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
